// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"Scrollbar_scrollbar__3hDvz","withoutZIndex":"Scrollbar_withoutZIndex__IMhGt"};